module.exports = __webpack_public_path__ + "static/media/c31-wifi.760035f5.png";